import React, { useState } from 'react';
import { Container, Dropdown, Offcanvas } from 'react-bootstrap';
import { useQuery, gql } from '@apollo/client';
import { Link, NavLink, useLocation } from 'react-router-dom';

//image here

import BrandImage from '../../assets/images/brandimage.jpg';

const Navbar = () => {
  const location = useLocation();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [navInfo, setNavInfo] = useState(false);

  //query for nav dropdown

  const GET_LOCATIONS = gql`
    query fetchMembers {
      members {
        nodes {
          id
          title
          slug
          uri
        }
      }
    }
  `;
  const { loading, data, error } = useQuery(GET_LOCATIONS);

  return (
    <>
      <section className='absnavbar'>
        <Container>
          <nav className=' navWrapper'>
            <Link to='/'>
              <figure className='navWrapper__navBrand'>
                <img src={BrandImage} alt='' />
              </figure>
            </Link>

            <ul className='navWrapper__navItems'>
              <li className='navWrapper__navItems--items'>
                <NavLink
                  className={`${
                    location.pathname === '/' ? 'activeSidebar' : 'notActive'
                  }`}
                  to='/'
                >
                  Home
                </NavLink>
              </li>
              <li>
                <Dropdown>
                  <Dropdown.Toggle id='dropdown-basic' className='customDwn'>
                    Team
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {data?.members.nodes.map((location, index) => (
                      <Link to={`/members/${location.slug}`} key={index}>
                        <div className='locationDropdown'>{location.title}</div>
                      </Link>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </li>
              <li className='navWrapper__navItems--items' onClick={handleClose}>
                <NavLink
                  className={(navData) =>
                    navData.isActive ? 'activeSidebarMob' : 'notActiveMob'
                  }
                  to='/vote
                  '
                >
                  How to Vote
                </NavLink>
              </li>
              <li className='navWrapper__navItems--items'>
                <NavLink
                  className={(navData) =>
                    navData.isActive ? 'activeSidebar' : 'notActive'
                  }
                  to='/news'
                >
                  News
                </NavLink>
              </li>
              <li className='navWrapper__navItems--items'>
                <NavLink
                  className={(navData) =>
                    navData.isActive ? 'activeSidebar' : 'notActive'
                  }
                  to='/gallery'
                >
                  Gallery
                </NavLink>
              </li>
              <li className='navWrapper__navItems--items'>
                <NavLink
                  className={(navData) =>
                    navData.isActive ? 'activeSidebar' : 'notActive'
                  }
                  to='/contact-us'
                >
                  Contact
                </NavLink>
              </li>
              <li className='navWrapper__navItems--items'>
                <Link
                  className={(navData) =>
                    navData.isActive ? 'activeSidebar' : 'notActive'
                  }
                  to='/contact-us'
                >
                  <button className='bton bton--primary bton--sm'>
                    Donate Now
                  </button>
                </Link>
              </li>
            </ul>

            <section className='navWrapper__mdNav'>
              <section className='nav_mdInfo'>
                {
                  <button
                    className='open_mdNav'
                    // onClick={() => setNavInfo(true)}
                    onClick={handleShow}
                  >
                    &#9776;
                  </button>
                }

                <Offcanvas show={show} onHide={handleClose} placement='end'>
                  <Offcanvas.Header closeButton> Menu</Offcanvas.Header>
                  <Offcanvas.Body>
                    <section
                      className={`mdNav_list_container ${
                        navInfo && ' showmdNav'
                      }`}
                    >
                      <ul className='mdNav_list ps-0'>
                        <li className='navWrapper__navItems--items'>
                          <NavLink
                            onClick={handleClose}
                            className={`${
                              location.pathname === '/'
                                ? 'activeSidebarMob'
                                : 'notActiveMob'
                            }`}
                            to='/'
                          >
                            Home
                          </NavLink>
                        </li>

                        <li className='navWrapper__navItems--items'>
                          <Dropdown>
                            <Dropdown.Toggle
                              id='dropdown-basic'
                              className='customDwn'
                            >
                              Team
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              {data?.members.nodes.map((location, index) => (
                                <Link
                                  to={`/members/${location.slug}`}
                                  key={index}
                                  onClick={handleClose}
                                >
                                  <div className='locationDropdown'>
                                    {location.title}
                                  </div>
                                </Link>
                              ))}
                            </Dropdown.Menu>
                          </Dropdown>
                        </li>
                        <li className='navWrapper__navItems--items'>
                          <NavLink
                            onClick={handleClose}
                            className={(navData) =>
                              navData.isActive
                                ? 'activeSidebarMob'
                                : 'notActiveMob'
                            }
                            to='/vote'
                          >
                            How to Vote
                          </NavLink>
                        </li>
                        <li className='navWrapper__navItems--items'>
                          <NavLink
                            onClick={handleClose}
                            className={(navData) =>
                              navData.isActive
                                ? 'activeSidebarMob'
                                : 'notActiveMob'
                            }
                            to='/news'
                          >
                            News
                          </NavLink>
                        </li>
                        <li className='navWrapper__navItems--items'>
                          <NavLink
                            onClick={handleClose}
                            className={(navData) =>
                              navData.isActive
                                ? 'activeSidebarMob'
                                : 'notActiveMob'
                            }
                            to='/gallery'
                          >
                            Gallery
                          </NavLink>
                        </li>

                        <li className='navWrapper__navItems--items'>
                          <NavLink
                            onClick={handleClose}
                            className={(navData) =>
                              navData.isActive
                                ? 'activeSidebarMob'
                                : 'notActiveMob'
                            }
                            to='/contact-us'
                          >
                            Contact
                          </NavLink>
                        </li>
                        <li className='navWrapper__navItems--items'>
                          <NavLink
                            onClick={handleClose}
                            className={(navData) =>
                              navData.isActive
                                ? 'activeSidebarMob'
                                : 'notActiveMob'
                            }
                            to='/contact-us'
                          >
                            <button className='bton bton--primary bton--sm'>
                              Donate Now
                            </button>
                          </NavLink>
                        </li>
                      </ul>
                    </section>
                  </Offcanvas.Body>
                </Offcanvas>
              </section>
            </section>
          </nav>
        </Container>
      </section>
    </>
  );
};

export default Navbar;
